import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0522dfda = () => interopDefault(import('../pages/affiliates.vue' /* webpackChunkName: "pages/affiliates" */))
const _0d6ab0b6 = () => interopDefault(import('../pages/agency-plans.vue' /* webpackChunkName: "pages/agency-plans" */))
const _6772f473 = () => interopDefault(import('../pages/analysis/index.vue' /* webpackChunkName: "pages/analysis/index" */))
const _0c3f75b6 = () => interopDefault(import('../pages/analytics/index.vue' /* webpackChunkName: "pages/analytics/index" */))
const _3e8adfbc = () => interopDefault(import('../pages/api-docs.vue' /* webpackChunkName: "pages/api-docs" */))
const _12f1648c = () => interopDefault(import('../pages/apply-promo.vue' /* webpackChunkName: "pages/apply-promo" */))
const _8ab580aa = () => interopDefault(import('../pages/automation.vue' /* webpackChunkName: "pages/automation" */))
const _3e8cdac2 = () => interopDefault(import('../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _17c15670 = () => interopDefault(import('../pages/charge.vue' /* webpackChunkName: "pages/charge" */))
const _1e5a4c83 = () => interopDefault(import('../pages/content-library.vue' /* webpackChunkName: "pages/content-library" */))
const _1b61f830 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _42f6eca9 = () => interopDefault(import('../pages/dms/index.vue' /* webpackChunkName: "pages/dms/index" */))
const _09182f73 = () => interopDefault(import('../pages/enterprise-contact-us.vue' /* webpackChunkName: "pages/enterprise-contact-us" */))
const _e5377492 = () => interopDefault(import('../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _2e3e30f6 = () => interopDefault(import('../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _47c0ead0 = () => interopDefault(import('../pages/legal/index.vue' /* webpackChunkName: "pages/legal/index" */))
const _62f3dfbe = () => interopDefault(import('../pages/list-of-nsfw-subreddits.vue' /* webpackChunkName: "pages/list-of-nsfw-subreddits" */))
const _5fb0a6f6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _fc4226c4 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _2cb982a2 = () => interopDefault(import('../pages/onboarding.vue' /* webpackChunkName: "pages/onboarding" */))
const _9601a1f4 = () => interopDefault(import('../pages/plans.vue' /* webpackChunkName: "pages/plans" */))
const _e7c36480 = () => interopDefault(import('../pages/rewards.vue' /* webpackChunkName: "pages/rewards" */))
const _42052c9d = () => interopDefault(import('../pages/safety-letter.vue' /* webpackChunkName: "pages/safety-letter" */))
const _bb74a7aa = () => interopDefault(import('../pages/schedule.vue' /* webpackChunkName: "pages/schedule" */))
const _1a9bd0fa = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _fdb05da8 = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _5485b206 = () => interopDefault(import('../pages/submissions/index.vue' /* webpackChunkName: "pages/submissions/index" */))
const _5118bc45 = () => interopDefault(import('../pages/subreddit-lists/index.vue' /* webpackChunkName: "pages/subreddit-lists/index" */))
const _4f796228 = () => interopDefault(import('../pages/subreddits/index.vue' /* webpackChunkName: "pages/subreddits/index" */))
const _09eb6f1f = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _7d4530d4 = () => interopDefault(import('../pages/trash.vue' /* webpackChunkName: "pages/trash" */))
const _6894babe = () => interopDefault(import('../pages/wrapped.vue' /* webpackChunkName: "pages/wrapped" */))
const _3d4212f3 = () => interopDefault(import('../pages/analysis/redditors.vue' /* webpackChunkName: "pages/analysis/redditors" */))
const _403ded9a = () => interopDefault(import('../pages/analytics/bluesky.vue' /* webpackChunkName: "pages/analytics/bluesky" */))
const _331819c3 = () => interopDefault(import('../pages/analytics/facebook.vue' /* webpackChunkName: "pages/analytics/facebook" */))
const _888442f6 = () => interopDefault(import('../pages/analytics/instagram.vue' /* webpackChunkName: "pages/analytics/instagram" */))
const _5e423466 = () => interopDefault(import('../pages/analytics/mastodon.vue' /* webpackChunkName: "pages/analytics/mastodon" */))
const _698ada6d = () => interopDefault(import('../pages/analytics/pinterest.vue' /* webpackChunkName: "pages/analytics/pinterest" */))
const _57903e9b = () => interopDefault(import('../pages/analytics/reddit.vue' /* webpackChunkName: "pages/analytics/reddit" */))
const _65e8c9bc = () => interopDefault(import('../pages/analytics/threads.vue' /* webpackChunkName: "pages/analytics/threads" */))
const _7f01e992 = () => interopDefault(import('../pages/analytics/tiktok.vue' /* webpackChunkName: "pages/analytics/tiktok" */))
const _72eaedce = () => interopDefault(import('../pages/analytics/tumblr.vue' /* webpackChunkName: "pages/analytics/tumblr" */))
const _f68568f4 = () => interopDefault(import('../pages/analytics/twitter.vue' /* webpackChunkName: "pages/analytics/twitter" */))
const _25a21794 = () => interopDefault(import('../pages/analytics/youtube.vue' /* webpackChunkName: "pages/analytics/youtube" */))
const _8d0d4c7e = () => interopDefault(import('../pages/bluesky/import.vue' /* webpackChunkName: "pages/bluesky/import" */))
const _8a7a6f88 = () => interopDefault(import('../pages/campaigns/create.vue' /* webpackChunkName: "pages/campaigns/create" */))
const _5633fde8 = () => interopDefault(import('../pages/catch/imgur.vue' /* webpackChunkName: "pages/catch/imgur" */))
const _439af335 = () => interopDefault(import('../pages/dms/create.vue' /* webpackChunkName: "pages/dms/create" */))
const _2b8a2746 = () => interopDefault(import('../pages/dms/inbox.vue' /* webpackChunkName: "pages/dms/inbox" */))
const _5b5780b6 = () => interopDefault(import('../pages/instagram/import.vue' /* webpackChunkName: "pages/instagram/import" */))
const _ca383264 = () => interopDefault(import('../pages/legal/privacy.vue' /* webpackChunkName: "pages/legal/privacy" */))
const _2d553c7e = () => interopDefault(import('../pages/legal/refunds.vue' /* webpackChunkName: "pages/legal/refunds" */))
const _f3c56e66 = () => interopDefault(import('../pages/legal/terms.vue' /* webpackChunkName: "pages/legal/terms" */))
const _dfe0ea34 = () => interopDefault(import('../pages/posts/inbox.vue' /* webpackChunkName: "pages/posts/inbox" */))
const _4d66f9dc = () => interopDefault(import('../pages/reddit/import.vue' /* webpackChunkName: "pages/reddit/import" */))
const _92d75078 = () => interopDefault(import('../pages/reddit/schedule.vue' /* webpackChunkName: "pages/reddit/schedule" */))
const _206bb9c7 = () => interopDefault(import('../pages/settings/change-email.vue' /* webpackChunkName: "pages/settings/change-email" */))
const _072ff140 = () => interopDefault(import('../pages/settings/change-password.vue' /* webpackChunkName: "pages/settings/change-password" */))
const _a829b064 = () => interopDefault(import('../pages/settings/checklist.vue' /* webpackChunkName: "pages/settings/checklist" */))
const _6f0581a0 = () => interopDefault(import('../pages/settings/clients.vue' /* webpackChunkName: "pages/settings/clients" */))
const _315eef68 = () => interopDefault(import('../pages/settings/custom-schedules.vue' /* webpackChunkName: "pages/settings/custom-schedules" */))
const _79e17184 = () => interopDefault(import('../pages/settings/danger-zone.vue' /* webpackChunkName: "pages/settings/danger-zone" */))
const _1b6defbc = () => interopDefault(import('../pages/settings/export.vue' /* webpackChunkName: "pages/settings/export" */))
const _6d9f91a8 = () => interopDefault(import('../pages/settings/manage-users.vue' /* webpackChunkName: "pages/settings/manage-users" */))
const _2a07b210 = () => interopDefault(import('../pages/settings/notifications.vue' /* webpackChunkName: "pages/settings/notifications" */))
const _1f0c0eb4 = () => interopDefault(import('../pages/settings/proxies.vue' /* webpackChunkName: "pages/settings/proxies" */))
const _2467f6b6 = () => interopDefault(import('../pages/settings/subscription.vue' /* webpackChunkName: "pages/settings/subscription" */))
const _f188b38a = () => interopDefault(import('../pages/submissions/bluesky.vue' /* webpackChunkName: "pages/submissions/bluesky" */))
const _685d157c = () => interopDefault(import('../pages/submissions/facebook.vue' /* webpackChunkName: "pages/submissions/facebook" */))
const _3a2ff2e6 = () => interopDefault(import('../pages/submissions/instagram.vue' /* webpackChunkName: "pages/submissions/instagram" */))
const _1208e036 = () => interopDefault(import('../pages/submissions/mastodon.vue' /* webpackChunkName: "pages/submissions/mastodon" */))
const _30062264 = () => interopDefault(import('../pages/submissions/pinterest.vue' /* webpackChunkName: "pages/submissions/pinterest" */))
const _51986dda = () => interopDefault(import('../pages/submissions/reddit.vue' /* webpackChunkName: "pages/submissions/reddit" */))
const _a632fb46 = () => interopDefault(import('../pages/submissions/threads.vue' /* webpackChunkName: "pages/submissions/threads" */))
const _8af18b14 = () => interopDefault(import('../pages/submissions/tiktok.vue' /* webpackChunkName: "pages/submissions/tiktok" */))
const _7eda8f50 = () => interopDefault(import('../pages/submissions/tumblr.vue' /* webpackChunkName: "pages/submissions/tumblr" */))
const _6889f7b2 = () => interopDefault(import('../pages/submissions/twitter.vue' /* webpackChunkName: "pages/submissions/twitter" */))
const _342cacd7 = () => interopDefault(import('../pages/submissions/youtube.vue' /* webpackChunkName: "pages/submissions/youtube" */))
const _5b2a086c = () => interopDefault(import('../pages/subreddits/discovery.vue' /* webpackChunkName: "pages/subreddits/discovery" */))
const _f2e64118 = () => interopDefault(import('../pages/subreddits/recommendations.vue' /* webpackChunkName: "pages/subreddits/recommendations" */))
const _0f06f35f = () => interopDefault(import('../pages/threads/import.vue' /* webpackChunkName: "pages/threads/import" */))
const _34d0e214 = () => interopDefault(import('../pages/tiktok/import.vue' /* webpackChunkName: "pages/tiktok/import" */))
const _834899e8 = () => interopDefault(import('../pages/tools/ai-social-media-generators.vue' /* webpackChunkName: "pages/tools/ai-social-media-generators" */))
const _5fce8fb4 = () => interopDefault(import('../pages/tools/bluesky-post-generator.vue' /* webpackChunkName: "pages/tools/bluesky-post-generator" */))
const _09d578b5 = () => interopDefault(import('../pages/tools/facebook-post-generator.vue' /* webpackChunkName: "pages/tools/facebook-post-generator" */))
const _0425e139 = () => interopDefault(import('../pages/tools/instagram-caption-generator.vue' /* webpackChunkName: "pages/tools/instagram-caption-generator" */))
const _55d463b2 = () => interopDefault(import('../pages/tools/mastodon-post-generator.vue' /* webpackChunkName: "pages/tools/mastodon-post-generator" */))
const _48ab3430 = () => interopDefault(import('../pages/tools/reddit-post-title-generator.vue' /* webpackChunkName: "pages/tools/reddit-post-title-generator" */))
const _40efab52 = () => interopDefault(import('../pages/tools/threads-post-generator.vue' /* webpackChunkName: "pages/tools/threads-post-generator" */))
const _1418f4e1 = () => interopDefault(import('../pages/tools/tiktok-caption-generator.vue' /* webpackChunkName: "pages/tools/tiktok-caption-generator" */))
const _47ef1830 = () => interopDefault(import('../pages/tools/x-twitter-tweet-generator.vue' /* webpackChunkName: "pages/tools/x-twitter-tweet-generator" */))
const _0c5bc3fa = () => interopDefault(import('../pages/tools/youtube-shorts-title-generator.vue' /* webpackChunkName: "pages/tools/youtube-shorts-title-generator" */))
const _6e068b56 = () => interopDefault(import('../pages/twitter/import.vue' /* webpackChunkName: "pages/twitter/import" */))
const _613ed734 = () => interopDefault(import('../pages/settings/accounts/bluesky.vue' /* webpackChunkName: "pages/settings/accounts/bluesky" */))
const _ef6b6712 = () => interopDefault(import('../pages/settings/accounts/facebook.vue' /* webpackChunkName: "pages/settings/accounts/facebook" */))
const _40a0b0bf = () => interopDefault(import('../pages/settings/accounts/imgur.vue' /* webpackChunkName: "pages/settings/accounts/imgur" */))
const _0cd20251 = () => interopDefault(import('../pages/settings/accounts/instagram.vue' /* webpackChunkName: "pages/settings/accounts/instagram" */))
const _991731cc = () => interopDefault(import('../pages/settings/accounts/mastodon.vue' /* webpackChunkName: "pages/settings/accounts/mastodon" */))
const _8ac2038e = () => interopDefault(import('../pages/settings/accounts/pinterest.vue' /* webpackChunkName: "pages/settings/accounts/pinterest" */))
const _01578e4f = () => interopDefault(import('../pages/settings/accounts/reddit.vue' /* webpackChunkName: "pages/settings/accounts/reddit" */))
const _4d058a9f = () => interopDefault(import('../pages/settings/accounts/redgifs.vue' /* webpackChunkName: "pages/settings/accounts/redgifs" */))
const _488696f6 = () => interopDefault(import('../pages/settings/accounts/secure-connect.vue' /* webpackChunkName: "pages/settings/accounts/secure-connect" */))
const _15e91ef0 = () => interopDefault(import('../pages/settings/accounts/threads.vue' /* webpackChunkName: "pages/settings/accounts/threads" */))
const _6a465aeb = () => interopDefault(import('../pages/settings/accounts/tiktok.vue' /* webpackChunkName: "pages/settings/accounts/tiktok" */))
const _7051d8cd = () => interopDefault(import('../pages/settings/accounts/tumblr.vue' /* webpackChunkName: "pages/settings/accounts/tumblr" */))
const _13dff252 = () => interopDefault(import('../pages/settings/accounts/twitter.vue' /* webpackChunkName: "pages/settings/accounts/twitter" */))
const _7c519b02 = () => interopDefault(import('../pages/settings/accounts/youtube.vue' /* webpackChunkName: "pages/settings/accounts/youtube" */))
const _2af35bb6 = () => interopDefault(import('../pages/settings/post-settings/reddit.vue' /* webpackChunkName: "pages/settings/post-settings/reddit" */))
const _53751ec1 = () => interopDefault(import('../pages/settings/post-settings/tiktok.vue' /* webpackChunkName: "pages/settings/post-settings/tiktok" */))
const _5089a93c = () => interopDefault(import('../pages/settings/post-settings/twitter.vue' /* webpackChunkName: "pages/settings/post-settings/twitter" */))
const _4c9456ce = () => interopDefault(import('../pages/confirm-email/_token.vue' /* webpackChunkName: "pages/confirm-email/_token" */))
const _5c0782d4 = () => interopDefault(import('../pages/connect/_token/index.vue' /* webpackChunkName: "pages/connect/_token/index" */))
const _4e80680b = () => interopDefault(import('../pages/r/_code.vue' /* webpackChunkName: "pages/r/_code" */))
const _32c1280c = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _10494260 = () => interopDefault(import('../pages/subreddit-lists/_category.vue' /* webpackChunkName: "pages/subreddit-lists/_category" */))
const _20f149a0 = () => interopDefault(import('../pages/subreddits/_subredditName.vue' /* webpackChunkName: "pages/subreddits/_subredditName" */))
const _442c2ba8 = () => interopDefault(import('../pages/subscribe/_planCode.vue' /* webpackChunkName: "pages/subscribe/_planCode" */))
const _0c10db8a = () => interopDefault(import('../pages/connect/_token/invalid.vue' /* webpackChunkName: "pages/connect/_token/invalid" */))
const _31a20b72 = () => interopDefault(import('../pages/connect/_token/success.vue' /* webpackChunkName: "pages/connect/_token/success" */))
const _222e1483 = () => interopDefault(import('../pages/join/_token/invalid.vue' /* webpackChunkName: "pages/join/_token/invalid" */))
const _0680096e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/affiliates",
    component: _0522dfda,
    name: "affiliates"
  }, {
    path: "/agency-plans",
    component: _0d6ab0b6,
    name: "agency-plans"
  }, {
    path: "/analysis",
    component: _6772f473,
    name: "analysis"
  }, {
    path: "/analytics",
    component: _0c3f75b6,
    name: "analytics"
  }, {
    path: "/api-docs",
    component: _3e8adfbc,
    name: "api-docs"
  }, {
    path: "/apply-promo",
    component: _12f1648c,
    name: "apply-promo"
  }, {
    path: "/automation",
    component: _8ab580aa,
    name: "automation"
  }, {
    path: "/campaigns",
    component: _3e8cdac2,
    name: "campaigns"
  }, {
    path: "/charge",
    component: _17c15670,
    name: "charge"
  }, {
    path: "/content-library",
    component: _1e5a4c83,
    name: "content-library"
  }, {
    path: "/dashboard",
    component: _1b61f830,
    name: "dashboard"
  }, {
    path: "/dms",
    component: _42f6eca9,
    name: "dms"
  }, {
    path: "/enterprise-contact-us",
    component: _09182f73,
    name: "enterprise-contact-us"
  }, {
    path: "/forgot",
    component: _e5377492,
    name: "forgot"
  }, {
    path: "/integrations",
    component: _2e3e30f6,
    name: "integrations"
  }, {
    path: "/legal",
    component: _47c0ead0,
    name: "legal"
  }, {
    path: "/list-of-nsfw-subreddits",
    component: _62f3dfbe,
    name: "list-of-nsfw-subreddits"
  }, {
    path: "/login",
    component: _5fb0a6f6,
    name: "login"
  }, {
    path: "/logout",
    component: _fc4226c4,
    name: "logout"
  }, {
    path: "/onboarding",
    component: _2cb982a2,
    name: "onboarding"
  }, {
    path: "/plans",
    component: _9601a1f4,
    name: "plans"
  }, {
    path: "/rewards",
    component: _e7c36480,
    name: "rewards"
  }, {
    path: "/safety-letter",
    component: _42052c9d,
    name: "safety-letter"
  }, {
    path: "/schedule",
    component: _bb74a7aa,
    name: "schedule"
  }, {
    path: "/settings",
    component: _1a9bd0fa,
    name: "settings"
  }, {
    path: "/signup",
    component: _fdb05da8,
    name: "signup"
  }, {
    path: "/submissions",
    component: _5485b206,
    name: "submissions"
  }, {
    path: "/subreddit-lists",
    component: _5118bc45,
    name: "subreddit-lists"
  }, {
    path: "/subreddits",
    component: _4f796228,
    name: "subreddits"
  }, {
    path: "/success",
    component: _09eb6f1f,
    name: "success"
  }, {
    path: "/trash",
    component: _7d4530d4,
    name: "trash"
  }, {
    path: "/wrapped",
    component: _6894babe,
    name: "wrapped"
  }, {
    path: "/analysis/redditors",
    component: _3d4212f3,
    name: "analysis:redditors"
  }, {
    path: "/analytics/bluesky",
    component: _403ded9a,
    name: "analytics:bluesky"
  }, {
    path: "/analytics/facebook",
    component: _331819c3,
    name: "analytics:facebook"
  }, {
    path: "/analytics/instagram",
    component: _888442f6,
    name: "analytics:instagram"
  }, {
    path: "/analytics/mastodon",
    component: _5e423466,
    name: "analytics:mastodon"
  }, {
    path: "/analytics/pinterest",
    component: _698ada6d,
    name: "analytics:pinterest"
  }, {
    path: "/analytics/reddit",
    component: _57903e9b,
    name: "analytics:reddit"
  }, {
    path: "/analytics/threads",
    component: _65e8c9bc,
    name: "analytics:threads"
  }, {
    path: "/analytics/tiktok",
    component: _7f01e992,
    name: "analytics:tiktok"
  }, {
    path: "/analytics/tumblr",
    component: _72eaedce,
    name: "analytics:tumblr"
  }, {
    path: "/analytics/twitter",
    component: _f68568f4,
    name: "analytics:twitter"
  }, {
    path: "/analytics/youtube",
    component: _25a21794,
    name: "analytics:youtube"
  }, {
    path: "/bluesky/import",
    component: _8d0d4c7e,
    name: "bluesky:import"
  }, {
    path: "/campaigns/create",
    component: _8a7a6f88,
    name: "campaigns:create"
  }, {
    path: "/catch/imgur",
    component: _5633fde8,
    name: "catch:imgur"
  }, {
    path: "/dms/create",
    component: _439af335,
    name: "dms:create"
  }, {
    path: "/dms/inbox",
    component: _2b8a2746,
    name: "dms:inbox"
  }, {
    path: "/instagram/import",
    component: _5b5780b6,
    name: "instagram:import"
  }, {
    path: "/legal/privacy",
    component: _ca383264,
    name: "legal:privacy"
  }, {
    path: "/legal/refunds",
    component: _2d553c7e,
    name: "legal:refunds"
  }, {
    path: "/legal/terms",
    component: _f3c56e66,
    name: "legal:terms"
  }, {
    path: "/posts/inbox",
    component: _dfe0ea34,
    name: "posts:inbox"
  }, {
    path: "/reddit/import",
    component: _4d66f9dc,
    name: "reddit:import"
  }, {
    path: "/reddit/schedule",
    component: _92d75078,
    name: "reddit:schedule"
  }, {
    path: "/settings/change-email",
    component: _206bb9c7,
    name: "settings:change-email"
  }, {
    path: "/settings/change-password",
    component: _072ff140,
    name: "settings:change-password"
  }, {
    path: "/settings/checklist",
    component: _a829b064,
    name: "settings:checklist"
  }, {
    path: "/settings/clients",
    component: _6f0581a0,
    name: "settings:clients"
  }, {
    path: "/settings/custom-schedules",
    component: _315eef68,
    name: "settings:custom-schedules"
  }, {
    path: "/settings/danger-zone",
    component: _79e17184,
    name: "settings:danger-zone"
  }, {
    path: "/settings/export",
    component: _1b6defbc,
    name: "settings:export"
  }, {
    path: "/settings/manage-users",
    component: _6d9f91a8,
    name: "settings:manage-users"
  }, {
    path: "/settings/notifications",
    component: _2a07b210,
    name: "settings:notifications"
  }, {
    path: "/settings/proxies",
    component: _1f0c0eb4,
    name: "settings:proxies"
  }, {
    path: "/settings/subscription",
    component: _2467f6b6,
    name: "settings:subscription"
  }, {
    path: "/submissions/bluesky",
    component: _f188b38a,
    name: "submissions:bluesky"
  }, {
    path: "/submissions/facebook",
    component: _685d157c,
    name: "submissions:facebook"
  }, {
    path: "/submissions/instagram",
    component: _3a2ff2e6,
    name: "submissions:instagram"
  }, {
    path: "/submissions/mastodon",
    component: _1208e036,
    name: "submissions:mastodon"
  }, {
    path: "/submissions/pinterest",
    component: _30062264,
    name: "submissions:pinterest"
  }, {
    path: "/submissions/reddit",
    component: _51986dda,
    name: "submissions:reddit"
  }, {
    path: "/submissions/threads",
    component: _a632fb46,
    name: "submissions:threads"
  }, {
    path: "/submissions/tiktok",
    component: _8af18b14,
    name: "submissions:tiktok"
  }, {
    path: "/submissions/tumblr",
    component: _7eda8f50,
    name: "submissions:tumblr"
  }, {
    path: "/submissions/twitter",
    component: _6889f7b2,
    name: "submissions:twitter"
  }, {
    path: "/submissions/youtube",
    component: _342cacd7,
    name: "submissions:youtube"
  }, {
    path: "/subreddits/discovery",
    component: _5b2a086c,
    name: "subreddits:discovery"
  }, {
    path: "/subreddits/recommendations",
    component: _f2e64118,
    name: "subreddits:recommendations"
  }, {
    path: "/threads/import",
    component: _0f06f35f,
    name: "threads:import"
  }, {
    path: "/tiktok/import",
    component: _34d0e214,
    name: "tiktok:import"
  }, {
    path: "/tools/ai-social-media-generators",
    component: _834899e8,
    name: "tools:ai-social-media-generators"
  }, {
    path: "/tools/bluesky-post-generator",
    component: _5fce8fb4,
    name: "tools:bluesky-post-generator"
  }, {
    path: "/tools/facebook-post-generator",
    component: _09d578b5,
    name: "tools:facebook-post-generator"
  }, {
    path: "/tools/instagram-caption-generator",
    component: _0425e139,
    name: "tools:instagram-caption-generator"
  }, {
    path: "/tools/mastodon-post-generator",
    component: _55d463b2,
    name: "tools:mastodon-post-generator"
  }, {
    path: "/tools/reddit-post-title-generator",
    component: _48ab3430,
    name: "tools:reddit-post-title-generator"
  }, {
    path: "/tools/threads-post-generator",
    component: _40efab52,
    name: "tools:threads-post-generator"
  }, {
    path: "/tools/tiktok-caption-generator",
    component: _1418f4e1,
    name: "tools:tiktok-caption-generator"
  }, {
    path: "/tools/x-twitter-tweet-generator",
    component: _47ef1830,
    name: "tools:x-twitter-tweet-generator"
  }, {
    path: "/tools/youtube-shorts-title-generator",
    component: _0c5bc3fa,
    name: "tools:youtube-shorts-title-generator"
  }, {
    path: "/twitter/import",
    component: _6e068b56,
    name: "twitter:import"
  }, {
    path: "/settings/accounts/bluesky",
    component: _613ed734,
    name: "settings:accounts:bluesky"
  }, {
    path: "/settings/accounts/facebook",
    component: _ef6b6712,
    name: "settings:accounts:facebook"
  }, {
    path: "/settings/accounts/imgur",
    component: _40a0b0bf,
    name: "settings:accounts:imgur"
  }, {
    path: "/settings/accounts/instagram",
    component: _0cd20251,
    name: "settings:accounts:instagram"
  }, {
    path: "/settings/accounts/mastodon",
    component: _991731cc,
    name: "settings:accounts:mastodon"
  }, {
    path: "/settings/accounts/pinterest",
    component: _8ac2038e,
    name: "settings:accounts:pinterest"
  }, {
    path: "/settings/accounts/reddit",
    component: _01578e4f,
    name: "settings:accounts:reddit"
  }, {
    path: "/settings/accounts/redgifs",
    component: _4d058a9f,
    name: "settings:accounts:redgifs"
  }, {
    path: "/settings/accounts/secure-connect",
    component: _488696f6,
    name: "settings:accounts:secure-connect"
  }, {
    path: "/settings/accounts/threads",
    component: _15e91ef0,
    name: "settings:accounts:threads"
  }, {
    path: "/settings/accounts/tiktok",
    component: _6a465aeb,
    name: "settings:accounts:tiktok"
  }, {
    path: "/settings/accounts/tumblr",
    component: _7051d8cd,
    name: "settings:accounts:tumblr"
  }, {
    path: "/settings/accounts/twitter",
    component: _13dff252,
    name: "settings:accounts:twitter"
  }, {
    path: "/settings/accounts/youtube",
    component: _7c519b02,
    name: "settings:accounts:youtube"
  }, {
    path: "/settings/post-settings/reddit",
    component: _2af35bb6,
    name: "settings:post-settings:reddit"
  }, {
    path: "/settings/post-settings/tiktok",
    component: _53751ec1,
    name: "settings:post-settings:tiktok"
  }, {
    path: "/settings/post-settings/twitter",
    component: _5089a93c,
    name: "settings:post-settings:twitter"
  }, {
    path: "/confirm-email/:token?",
    component: _4c9456ce,
    name: "confirm-email:token"
  }, {
    path: "/connect/:token",
    component: _5c0782d4,
    name: "connect:token"
  }, {
    path: "/r/:code?",
    component: _4e80680b,
    name: "r:code"
  }, {
    path: "/reset-password/:token?",
    component: _32c1280c,
    name: "reset-password:token"
  }, {
    path: "/subreddit-lists/:category",
    component: _10494260,
    name: "subreddit-lists:category"
  }, {
    path: "/subreddits/:subredditName",
    component: _20f149a0,
    name: "subreddits:subredditName"
  }, {
    path: "/subscribe/:planCode?",
    component: _442c2ba8,
    name: "subscribe:planCode"
  }, {
    path: "/connect/:token?/invalid",
    component: _0c10db8a,
    name: "connect:token:invalid"
  }, {
    path: "/connect/:token?/success",
    component: _31a20b72,
    name: "connect:token:success"
  }, {
    path: "/join/:token?/invalid",
    component: _222e1483,
    name: "join:token:invalid"
  }, {
    path: "/",
    component: _0680096e,
    name: "index"
  }, {
    path: "/posts/edit/:postId",
    component: _92d75078,
    props: true,
    name: "posts:edit"
  }, {
    path: "/reddit/schedule/:postId",
    component: _92d75078,
    props: true,
    name: "reddit:edit"
  }, {
    path: "/twitter/schedule/",
    component: _bb74a7aa,
    props: {"platform":"twitter"},
    name: "twitter:schedule"
  }, {
    path: "/threads/schedule/",
    component: _bb74a7aa,
    props: {"platform":"threads"},
    name: "threads:schedule"
  }, {
    path: "/instagram/schedule/",
    component: _bb74a7aa,
    props: {"platform":"instagram"},
    name: "instagram:schedule"
  }, {
    path: "/facebook/schedule/",
    component: _bb74a7aa,
    props: {"platform":"facebook"},
    name: "facebook:schedule"
  }, {
    path: "/tiktok/schedule/",
    component: _bb74a7aa,
    props: {"platform":"tiktok"},
    name: "tiktok:schedule"
  }, {
    path: "/youtube/schedule/",
    component: _bb74a7aa,
    props: {"platform":"youtube"},
    name: "youtube:schedule"
  }, {
    path: "/pinterest/schedule/",
    component: _bb74a7aa,
    props: {"platform":"pinterest"},
    name: "pinterest:schedule"
  }, {
    path: "/bluesky/schedule/",
    component: _bb74a7aa,
    props: {"platform":"bluesky"},
    name: "bluesky:schedule"
  }, {
    path: "/tumblr/schedule/",
    component: _bb74a7aa,
    props: {"platform":"tumblr"},
    name: "tumblr:schedule"
  }, {
    path: "/mastodon/schedule/",
    component: _bb74a7aa,
    props: {"platform":"mastodon"},
    name: "mastodon:schedule"
  }, {
    path: "/dms/edit/:dmId",
    component: _439af335,
    props: true,
    name: "dms:edit"
  }, {
    path: "/campaigns/edit/:campaignId",
    component: _8a7a6f88,
    props: true,
    name: "campaigns:edit"
  }, {
    path: "/analysis/subreddit/:subredditName",
    component: _6772f473,
    props: true,
    name: "analysis:name"
  }, {
    path: "/analysis/redditors/:username",
    component: _3d4212f3,
    props: true,
    name: "redditors:name"
  }, {
    path: "/signin",
    component: _5fb0a6f6,
    meta: {"redirect":true}
  }, {
    path: "/terms",
    component: _f3c56e66,
    meta: {"redirect":true}
  }, {
    path: "/privacy",
    component: _ca383264,
    meta: {"redirect":true}
  }, {
    path: "/refunds",
    component: _2d553c7e,
    meta: {"redirect":true}
  }, {
    path: "/settings",
    component: _1a9bd0fa,
    meta: {"redirect":true}
  }, {
    path: "/profile",
    component: _1a9bd0fa,
    meta: {"redirect":true}
  }, {
    path: "/profile/accounts",
    component: _01578e4f,
    meta: {"redirect":true}
  }, {
    path: "/profile/notifications",
    component: _2a07b210,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-email",
    component: _206bb9c7,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-password",
    component: _072ff140,
    meta: {"redirect":true}
  }, {
    path: "/profile/checklist",
    component: _a829b064,
    meta: {"redirect":true}
  }, {
    path: "/profile/post-settings",
    component: _2af35bb6,
    meta: {"redirect":true}
  }, {
    path: "/profile/subscription",
    component: _2467f6b6,
    meta: {"redirect":true}
  }, {
    path: "/posts/create",
    component: _92d75078,
    meta: {"redirect":true}
  }, {
    path: "/import",
    component: _4d66f9dc,
    meta: {"redirect":true}
  }, {
    path: "/settings/accounts",
    component: _01578e4f,
    meta: {"redirect":true}
  }, {
    path: "/settings/post-settings",
    component: _2af35bb6,
    meta: {"redirect":true}
  }, {
    path: "/help",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/';
        }
  }, {
    path: "/api-docs",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/api-docs/postpone-api';
        }
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
